import React from 'react';
import { inputStyles } from './FormStyles';

const SizeControl = ({ element, onElementChange, elementKey }) => {
  return (
    <div>
      <span className={inputStyles.label}>Font Size</span>
      <input
        type="range"
        min={10}
        max={100}
        value={element.fontSize}
        onChange={(e) => onElementChange(elementKey, 'fontSize', parseInt(e.target.value))}
        className="w-full"
      />
      {/* <div className="text-sm text-gray-500 mt-1">
        {element.fontSize}px
      </div> */}
    </div>
  );
};

export default SizeControl;
